/**
 * @desc 新品下单-审批
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.ProductOrderApprovalRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productOrder/approval`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
